import Api from '../service/Api';

export default {
  findAll:() => Api.get('instrutores'),
  findByCpf: cpf => Api.get(`instrutores/${cpf}`),
  findByName: name => Api.get(`instrutores/nome/${name}`),
  getSchedule: (cpf, id_servico) => Api.get(`/instrutores/${cpf}/agenda/servico${id_servico}`),
  getConfigSchedule: (cpf, id_servico) => Api.get(`/instrutores/${cpf}/agenda/config/servico/${id_servico}`)
};
